import { createAction } from "redux-actions";

// create new quote
export const CREATE_QUOTE = "CREATE_QUOTE";
export const createQuote = createAction(CREATE_QUOTE);

export const CREATE_QUOTE_PENDING = "CREATE_QUOTE_PENDING";
export const createQuotePending = createAction(CREATE_QUOTE_PENDING);

export const CREATE_QUOTE_REQUESTED = "CREATE_QUOTE_REQUESTED";
export const createQuoteRequested = createAction(CREATE_QUOTE_REQUESTED);

export const CREATE_QUOTE_FAILURE = "CREATE_QUOTE_FAILURE";
export const createQuoteFailure = createAction(CREATE_QUOTE_FAILURE);

export const CREATE_QUOTE_SUCCESS = "CREATE_QUOTE_SUCCESS";
export const createQuoteSuccess = createAction(CREATE_QUOTE_SUCCESS);

// fetch all quotes
export const FETCH_QUOTES = "FETCH_QUOTES";
export const fetchQuotes = createAction(FETCH_QUOTES);

export const FETCH_QUOTE_REQUESTED = "FETCH_QUOTE_REQUESTED";
export const fetchQuoteRequested = createAction(FETCH_QUOTE_REQUESTED);

export const FETCH_QUOTE_FAILURE = "FETCH_QUOTE_FAILURE";
export const fetchQuoteFailure = createAction(FETCH_QUOTE_FAILURE);

export const FETCH_QUOTE_SUCCESS = "FETCH_QUOTE_SUCCESS";
export const fetchQuoteSuccess = createAction(FETCH_QUOTE_SUCCESS);

// fetch single quote detail
export const FETCH_QUOTE_BY_ID = "FETCH_QUOTE_BY_ID";
export const fetchSingleQuoteById = createAction(FETCH_QUOTE_BY_ID);

export const FETCH_SINGLE_QUOTE_BY_ID_REQUESTED = "FETCH_SINGLE_QUOTE_BY_ID_REQUESTED";
export const fetchSingleQuoteByIdRequested = createAction(FETCH_SINGLE_QUOTE_BY_ID_REQUESTED);

export const FETCH_SINGLE_QUOTE_BY_ID_FAILURE = "FETCH_SINGLE_QUOTE_FAILURE";
export const fetchSingleQuoteByIdFailure = createAction(FETCH_SINGLE_QUOTE_BY_ID_FAILURE);

export const FETCH_SINGLE_QUOTE_BY_ID_SUCCESS = "FETCH_SINGLE_QUOTE_SUCCESS";
export const fetchSingleQuoteByIdSuccess = createAction(FETCH_SINGLE_QUOTE_BY_ID_SUCCESS);

// update quote detail
export const UPDATE_QUOTE = "UPDATE_QUOTE";
export const updateQuote = createAction(UPDATE_QUOTE);

export const UPDATE_QUOTE_PENDING = "UPDATE_QUOTE_PENDING";
export const updateQuotePending = createAction(UPDATE_QUOTE_PENDING);

export const UPDATE_QUOTE_REQUESTED = "UPDATE_QUOTE_REQUESTED";
export const updateQuoteRequested = createAction(UPDATE_QUOTE_REQUESTED);

export const UPDATE_QUOTE_FAILURE = "UPDATE_QUOTE_FAILURE";
export const updateQuoteFailure = createAction(UPDATE_QUOTE_FAILURE);

export const UPDATE_QUOTE_SUCCESS = "UPDATE_QUOTE_SUCCESS";
export const updateQuoteSuccess = createAction(UPDATE_QUOTE_SUCCESS);

// update quote with status detail
export const UPDATE_QUOTE_WITH_STATUS = "UPDATE_QUOTE_WITH_STATUS";
export const updateQuoteWithStatus = createAction(UPDATE_QUOTE_WITH_STATUS);

export const FETCH_QUOTE_BY_USER_ID = "FETCH_QUOTE_BY_USER_ID";
export const fetchQuoteByUserId = createAction(FETCH_QUOTE_BY_USER_ID);

export const FETCH_QUOTE_BY_USER_ID_FAILURE = "FETCH_QUOTE_BY_USER_ID_FAILURE";
export const fetchQuoteByUserIdFailure = createAction(FETCH_QUOTE_BY_USER_ID_FAILURE);

export const FETCH_QUOTE_BY_USER_ID_REQUESTED = "FETCH_QUOTE_BY_USER_ID_REQUESTED";
export const fetchQuoteByUserIdRequested = createAction(FETCH_QUOTE_BY_USER_ID_REQUESTED);

export const FETCH_QUOTE_BY_USER_ID_SUCCESS = "FETCH_QUOTE_BY_USER_ID_SUCCESS";
export const fetchQuoteByUserIdSuccess = createAction(FETCH_QUOTE_BY_USER_ID_SUCCESS);
